var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6602 11.5941L10.7043 1.27812C9.73154 -0.42604 7.27153 -0.42604 6.30222 1.27812L0.342906 11.5941C-0.6299 13.2982 0.580859 15.4153 2.54397 15.4153H14.4381C16.4012 15.4153 17.633 13.2772 16.6602 11.5941ZM8.49978 13.1268C7.98189 13.1268 7.55147 12.6964 7.55147 12.1785C7.55147 11.6606 7.98189 11.2301 8.49978 11.2301C9.01768 11.2301 9.4481 11.6606 9.4271 12.2029C9.45159 12.6964 8.99669 13.1268 8.49978 13.1268ZM9.36411 6.99598C9.32212 7.73084 9.27663 8.46219 9.23464 9.19705C9.21364 9.435 9.21364 9.65196 9.21364 9.88641C9.19265 10.2748 8.88821 10.5758 8.49978 10.5758C8.11136 10.5758 7.81042 10.2958 7.78593 9.9074C7.72294 8.76313 7.65645 7.63986 7.59346 6.49558C7.57247 6.19464 7.55147 5.8902 7.52698 5.58926C7.52698 5.09236 7.80692 4.68294 8.26183 4.55347C8.71674 4.44499 9.16815 4.66195 9.36411 5.09236C9.4306 5.24283 9.4516 5.3933 9.4516 5.56827C9.4306 6.04767 9.38511 6.52358 9.36411 6.99598Z",
    fill: "#F22B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaError);
export default __webpack_public_path__ + "static/media/media_error.c305bd94bae7ee8848a91a06f5ec59f0.svg";
export { ForwardRef as ReactComponent };